// extracted by mini-css-extract-plugin
export default {"releaseContainer":"WhatsNew_releaseContainer__mP-da","releaseIcon":"WhatsNew_releaseIcon__xMMjq"};